import React from "react";
import { Viewport as StyledViewport } from "./Viewport.styles";
import { ToastViewportProps } from "./Toast.types";

/**
 * Toast viewport for positioning toasts
 */
export const Viewport = (props: ToastViewportProps) => (
  <StyledViewport {...props} />
);
